<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="الخاتم-العجيب">
<h3 style="text-align:right;padding-top:150px">أحلام يحيى جحاف</h3>
<p style="text-align: right;font-family:Sakkal Majalla"><strong>كاتبة يمنية.. حاصلة على درجة الماجستير في الإدارة.</strong></p>
<p style="text-align: right;font-family:Sakkal Majalla"><strong>عملت في مجال التعليم معلِّمة لمادة الرياضيات، ثم انتقلت للعمل مدربة ومعدة أدلَّة وحقائب تدريبية بقطاع التدريب في وزارة التربية والتعليم.</strong></p>
<p style="text-align: right;font-family:Sakkal Majalla"><strong>نُشر لها عدد من القصص القصيرة مع آخرين في كتابين: "<em>خطوات - مبدعون من أجل حقوق الأطفال"</em> و"<em>خطوات 2</em>" عبر مؤسسة إبحار للطفولة والإبداع، كما شاركت في عدد من مسابقات القصة القصيرة، ونُشرت لها قصص فائزة في عدد من الكتب الجماعية: <em>"المنفيون إلى جوار السحاب"</em> المكتبة العربية للنشر والتوزيع، <em>"صندوق الدنيا"</em> لدار زين للنشر والتوزيع، <em>"شموس"</em> لدار مها للنشر والتوزيع، و<em>"سبيل الأمم"</em> مع مبادرة حلم الوصول.</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?76a4b89a